const locationGrouping = {
    group: () => 'admin/group',
    groupMappingList: () => `admin/mapping`,
    remainingPincodesList: () => `admin/remaining-pincodes`,
    updateGroup: (id:string) => `admin/group/${id}`,
    getGroupById: (id:string) => `admin/group/${id}`,

}
export default locationGrouping